import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.37744 2.25C7.75612 2.25 7.25244 2.75368 7.25244 3.375V14.6257C7.25244 15.2471 7.75612 15.7507 8.37744 15.7507H9.62994C10.2513 15.7507 10.7549 15.2471 10.7549 14.6257V3.375C10.7549 2.75368 10.2513 2.25 9.62994 2.25H8.37744Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.375 9.75073C2.75368 9.75073 2.25 10.2544 2.25 10.8757V14.6257C2.25 15.2471 2.75368 15.7507 3.375 15.7507H4.6275C5.24882 15.7507 5.7525 15.2471 5.7525 14.6257V10.8757C5.7525 10.2544 5.24882 9.75073 4.6275 9.75073H3.375Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.2549 7.125C12.2549 6.50368 12.7586 6 13.3799 6H14.6324C15.2537 6 15.7574 6.50368 15.7574 7.125V14.6257C15.7574 15.2471 15.2537 15.7507 14.6324 15.7507H13.3799C12.7586 15.7507 12.2549 15.2471 12.2549 14.6257V7.125Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }